// extracted by mini-css-extract-plugin
export default {"item_label":"nx98qpCNbcMKAMHc5bdh"};